import { PrismicPageParser } from "../../shared/utils/prismicPageParser"
import cx from "classnames"
import styles from "./ArtistResidencyContainer.module.scss"

const ArtistResidencyContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section
      id="mm-artist-residency"
      className={cx(styles.residency, "pageContainer")}
      aria-label="Artist Residency House"
    >
      <PrismicPageParser pageData={data} pageId={pageId} />
    </section>
  )
}

export default ArtistResidencyContainer
